export default __webpack_public_path__ + "static/facebookLogo-2bea8800b3f2e90e2e3e44699abcd65b.svg";